import React, { useEffect } from 'react';
import {
  connectHitsPerPage
} from 'react-instantsearch-dom';
import './HitsPerPageLabel.css';

const HitsPerPageLabel = ({ currentRefinement, items =[], refine }) => {

  useEffect(() => {
      refine(12);
  }, []);

  const currentItem = items.find(item => item.value === currentRefinement);
  return (
    <div className="hits-per-page-label">
        <label>
         {items.map(item => (
          <a
            key={item.value}
            href="#!"
            className={item.value === currentRefinement? 'active':''}
            onClick={(e)=>{
              e.preventDefault();
              refine(item.value);
            }}
          >
            {item.label}
          </a>

         ))}
    {/*       <span>{currentRefinement ? currentItem.label : currentRefinement}</span> */}
        </label>
    </div>
  );
};


export default connectHitsPerPage(HitsPerPageLabel);